export default "__VITE_ASSET__B3qw6qEh__"